module.exports = __webpack_public_path__ + "img/img-box-services-sitebuild-right.df2ff3e7.png";